import { lazy } from 'react';

// Redux
// import { useSelector } from 'react-redux';

// Routes page
const ThemeA = lazy(() => import("./templates/theme-a/PageRoute"));
const ThemeB = lazy(() => import("./templates/theme-b/PageRoute"));

const selectTheme = process.env?.REACT_APP_SELECT_THEME;

const ViewsRoutes = () => {
    const routesRouter = () => {
        if (selectTheme === "themeb") {
            return <ThemeB />;
        }

        return <ThemeA />;
    };

    return routesRouter();
};

export default ViewsRoutes;